import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=fc4ccf18&scoped=true&"
import script from "./Customer.vue?vue&type=script&lang=js&"
export * from "./Customer.vue?vue&type=script&lang=js&"
import style0 from "./customer.scss?vue&type=style&index=0&id=fc4ccf18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4ccf18",
  null
  
)

export default component.exports